// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".panel-container[data-v-424a8133]{height:100%}.title[data-v-424a8133]{padding:10px 0 0;color:var(--main-theme-color);letter-spacing:normal}[data-v-424a8133] .el-divider{background-color:var(--main-theme-color)}", ""]);
// Exports
module.exports = exports;
